import { useEffect } from "react";
import LegalFooter from "@/components/LegalFooter";

export default function DataDeletion() {
  useEffect(() => {
    document.title = "Data Deletion Instructions — Comms Fusion Pro";
  }, []);

  return (
    <>
      <main className="min-h-screen bg-background text-foreground py-12 px-6">
        <article className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">Data Deletion Instructions</h1>
          <p className="text-sm text-muted-foreground mb-8">How to request deletion of your data from Comms Fusion Pro.</p>

          <section className="space-y-4 text-sm leading-relaxed">
            <p>
              You can request the permanent deletion of your account and all associated
              data (contacts, conversations, automations, integrations) at any time.
            </p>

            <h2 className="text-xl font-semibold mt-6">Self-service</h2>
            <ol className="list-decimal pl-6 space-y-1">
              <li>Sign in to your workspace at <a className="text-primary underline" href="/login">/login</a>.</li>
              <li>Go to <strong>Settings → Workspace</strong>.</li>
              <li>Click <strong>Delete workspace</strong> and confirm.</li>
            </ol>

            <h2 className="text-xl font-semibold mt-6">By email</h2>
            <p>
              Send a deletion request from the email associated with your account to{" "}
              <a className="text-primary underline" href="mailto:support@klicko.org">support@klicko.org</a>{" "}
              with the subject "Data Deletion Request". Include your workspace name or ID.
            </p>

            <h2 className="text-xl font-semibold mt-6">Timeline</h2>
            <p>
              Deletion is processed within 30 days. Some data may be retained longer where
              required by law (e.g., billing records for tax purposes).
            </p>

            <h2 className="text-xl font-semibold mt-6">Facebook / Meta data</h2>
            <p>
              If you connected WhatsApp Business via Meta's Embedded Signup, all stored
              tokens and WhatsApp Business Account references are removed during deletion.
              You should also revoke our app's access in your{" "}
              <a className="text-primary underline" href="https://www.facebook.com/settings?tab=business_tools" target="_blank" rel="noreferrer">
                Meta Business Tools settings
              </a>.
            </p>
          </section>
        </article>
      </main>
      <LegalFooter />
    </>
  );
}
